// components/timeline/Weeks.tsx
import { WeeksArea } from '../../styles/timeline/gridAreas'
import { Week } from './week'

interface WeeksProps {
  start: Date
  showDates?: boolean
  small?: boolean
}

export const Weeks = ({ start, showDates = true, small = false}: WeeksProps) => {
  return (
    <WeeksArea
      css={{

        gridTemplateColumns: '1fr'
      }}
      small={small}

    >

          <Week start={start} week={0} showDates={showDates} />
    </WeeksArea>
  )
}